import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import AppFooter from "./components/shared/AppFooter";
import AppHeader from "./components/shared/AppHeader";
import "./css/App.css";
import Education from "./pages/Education";
import Work from "./pages/Work";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectSingle from "./pages/ProjectSingle";
import { AnimatePresence } from "framer-motion";
import UseScrollToTop from "./hooks/useScrollToTop";

function App() {
  return (
    <AnimatePresence>
      <div className=" bg-secondary-light dark:bg-primary-dark transition duration-300">
        <Router>
          <ScrollToTop />
          <AppHeader />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectSingle />} />
            <Route path="education" element={<Education />} />
            <Route path="work" element={<Work />} />
          </Routes>
          <AppFooter />
        </Router>
        <UseScrollToTop />
      </div>
    </AnimatePresence>
  );
}

export default App;
